<ng-container *transloco="let t">
    <div class="w-full px-4 sm:px-16">
        <!-- LOGO & INSTAGRAM -->
        <div class="flex flex-wrap items-center justify-between gap-4 py-4">
            <div class="flex-none w-24 sm:w-32">
                <img src="/assets/images/logo/lagarage_logo.svg">
            </div>
            <div class="flex-none">
                <a href="https://www.instagram.com/lagerage.at/" target="_blank" class="flex flex-row items-center">
                    <p class="mr-2"> {{t('footer-follow-us')}}</p>
                    <mat-icon svgIcon="feather:instagram" class="primary text-white"></mat-icon>
                </a>
            </div>
        </div>

        <!-- HORIZONTAL LINE -->
        <div class="">
            <hr class="bg-primary">
        </div>


        <div class="flex flex-col md:flex-row">
            <div class="flex flex-col md:flex-row justify-between w-full ">
                <div class="flex flex-col mb-8">
                    <h1 class="text-2xl mb-4">Lagerage</h1>
                    <a [href]="landing.href('home')" class="text-primary underline">{{t('footer-self-storage')}}</a>
                    <a [href]="landing.href('immobilien')" class="text-primary underline">{{t('footer-immobilien')}}</a>
                </div>
                <div class="flex flex-col mb-8">
                    <h1 class="text-2xl mb-4 ">{{t('footer-title-general')}}</h1>
                    <a [href]="landing.href('about')" class="text-primary underline">{{t('about-us')}}</a>
                    <a [href]="landing.href('impressum')" class="text-primary underline">{{t('impressum-heading')}}</a>
                    <a [href]="landing.href('faq')" class="text-primary underline">{{t('self-storage-faqs-pre-title')}}</a>
                </div>
                <div class="flex flex-col mb-8">
                    <h1 class="text-2xl mb-4">{{t('text-contact-us')}}</h1>
                    <div><a href="tel:+436542218722">{{t('text-phone')}}: <span class="text-primary underline">+43 6542 218722</span></a> (Mo - Fr 09:00 - 13:00 Uhr)</div>
                    <a href="mailto:office@lagerage.at">{{t('text-email')}}: <span class="text-primary underline">office@lagerage.at</span></a>
                    <a href="https://goo.gl/maps/SoaoH8DiYMwBRde19">{{t('text-address')}}:<span
                        class="text-primary underline"> Seespitzstraße 8, 5700 Zell am See</span></a>
                </div>
                <div class="flex flex-col mb-8 mr-2">
                    <h1 class="text-2xl mb-4" [innerHTML]="t('footer-title-payment-methods')"></h1>
                    <div class="text-primary ">{{t('footer-payments-credit-card')}}</div>
                    <a mat-flat-button class="bg-primary text-black mt-4 w-48" [href]="landing.href('widerruf')">
                        Vertrag widerrufen
                    </a>
                </div>
                <div class="flex flex-col mb-8">
                    <h1 class="text-2xl mb-4 ">{{ t('footer-documents') }}</h1>
                    <a class="link text-primary underline" href="javascript:void(0)" *ngFor="let doc of footerDocuments"
                       (click)="openDocument(doc)">{{doc.name}}</a>
                </div>
            </div>
        </div>
    </div>

</ng-container>
